// src/components/LoadingScreen.jsx
import React, { useState, useEffect, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const LoadingScreen = () => {
  const [progress, setProgress] = useState(0);
  const [isComplete, setIsComplete] = useState(false);
  const intervalRef = useRef(null);

  useEffect(() => {
    intervalRef.current = setInterval(() => {
      setProgress(prev => {
        const next = prev + 2.5;
        if (next >= 100) {
          clearInterval(intervalRef.current);
          setTimeout(() => setIsComplete(true), 350);
          return 100;
        }
        return next;
      });
    }, 28);

    return () => clearInterval(intervalRef.current);
  }, []);

  return (
    <AnimatePresence>
      {!isComplete && (
        <motion.div
          initial={{ opacity: 1 }}
          exit={{ opacity: 0, scale: 1.05, filter: "blur(10px)", transition: { duration: 0.6 } }}
          style={{
            position: 'fixed',
            inset: 0,
            zIndex: 10000,
            background: '#050505', 
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            direction: 'ltr',
          }}
        >
          {/* Logo Section */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            style={{ marginBottom: '30px', textAlign: 'center' }}
          >
            <img 
              // المسار المباشر من داخل مجلد public
              src="assets/images/lawaseq-logo.png" 
              alt="LAWASEQ Logo"
              style={{
                width: 'clamp(250px, 50vw, 400px)', // حجم اللوجو كما في التصميم
                height: 'auto',
                display: 'block',
              }}
              // للتأكد في حال وجود خطأ، سيظهر في الكونسول المسار الكامل
              onError={(e) => console.error("Image not found at:", e.target.src)}
            />
          </motion.div>

          {/* Progress Bar Container */}
          <div style={{ width: 'clamp(280px, 60vw, 450px)', textAlign: 'center' }}>
            <div style={{
              height: '3px',
              background: 'rgba(255,255,255,0.1)',
              borderRadius: '10px',
              overflow: 'hidden'
            }}>
              <motion.div
                style={{
                  height: '100%',
                  background: 'linear-gradient(90deg, #8B1A1A, #D4AF37)',
                  width: `${progress}%`,
                  boxShadow: '0 0 15px #D4AF37',
                }}
              />
            </div>
            
            <div style={{
              display: 'flex', 
              justifyContent: 'space-between', 
              marginTop: '10px',
              fontFamily: 'monospace',
              fontSize: '0.75rem',
              color: 'rgba(255,255,255,0.4)'
            }}>
              <span>0%</span>
              <span style={{ color: '#D4AF37', letterSpacing: '2px', fontWeight: 'bold' }}>
                INDUSTRIAL PRINTING SOLUTIONS
              </span>
              <span>100%</span>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default LoadingScreen;